import Proxy from 'es6-proxy-polyfill';
import { get } from 'lodash';
import { addUrlParams, resolveUrl, isServer } from '@zk/framework-vue';
import docPath from './doc-path';
import { isOverseasVersion } from '../util';
import { useRootInstance } from '../util/useRootInstance';

const getResourceUrl = (variable, path) => {
  const config = clientCfg || cfg;
  const url = resolveUrl(`${config[variable]}${path}`);
  return `${addUrlParams(url, { t: config.versionNumber })}`;
};
const envConfigs = { ...process.env };

let clientCfg;
const cfg = {
  ...envConfigs,
  versionNumber: process.env.VUE_APP_BUILD_TIMESTAMP || String(Date.now()),
  getResourceUrl
};

const getClientCfg = () => ({
  ...envConfigs,
  ...(window.$config || {}),
  versionNumber: [window.currentAppHash || '', window.buildTimestamp || Date.now()].join('.'),
  getResourceUrl
});

const getDocUrl = (keyOrPath, str = '') => {
  const path = window.$config?.docPath?.[keyOrPath] || docPath[keyOrPath] || keyOrPath || '';
  const lang = useRootInstance()?.$i18n?.locale || 'zh';
  const domain = isOverseasVersion ? config.VUE_APP_DOC_URL : `${config.VUE_APP_DOC_URL + lang}/docs`;
  const url = resolveUrl(`${domain}/${path}`);
  return `${url}${str}`;
};

const config = isServer ? cfg : new Proxy({}, {
  get (target, p) {
    if (p === 'getDocUrl') {
      return getDocUrl;
    }
    if (!clientCfg && window.$config) {
      clientCfg = getClientCfg();
    }
    return get(clientCfg || cfg, p) || null;
  }
});

export default config;
